import styled from "styled-components";

export const ZmExpandedDetails = styled.div`
  padding: 24px 48px 48px;
`;

export const ZmDeclarationsSection = styled.div`
  margin-top: 32px;
`;
